export default __webpack_public_path__ + "static/media/aboutUs.c4de8f5a.jpg";